<template>
  <div class="pb-8">
    <h1 class="text-2xl mb-6">
      Création d'articles Via le process Discover
      <!-- <dag-info :dags="page.dags" /> -->
    </h1>

    <v-card class="mb-6 pa-2" outlined>
      <v-row class="ma-3">
        <v-col cols="12">
          <filters></filters>
        </v-col>
      </v-row>
    </v-card>

    <v-row v-show="page.clickedOnce">
      <v-col cols="12">
        <post-results @valueChanged="selectPosts" />
      </v-col>
      <v-col cols="12" class="pb-6" v-show="page.selectedPosts.length > 0">
        <v-card class="pa-3" outlined>
          <v-row>
            <v-col cols="12" md="3">
              <filter-site-out @valueChanged="handleSiteOutChange"
            /></v-col>
            <v-col cols="12" md="3">
              <custom-prompt-template-filter
                :noUrl="true"
                :forceSiteId="page.site_id_out"
                store="aiFactory"
                preselect-default
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-checkbox
                v-model="page.keepTitle"
                hide-details
                dense
                label="Conserver le titre"
                class="mt-0"
              />
              <v-checkbox
                v-model="page.keepImage"
                hide-details
                dense
                label="Conserver l'image"
                class="mt-1"
              />
              <!-- Sans l'image de la source, l'utilisateur choisit le mode image. -->
              <aif-image-mode-toggle
                v-if="!page.keepImage"
                v-model="imageHandler"
                layout="select"
                label="Image"
                class="mt-3"
              />
            </v-col>
            <v-col cols="12" md="3" class="text-right">
              <v-btn
                color="primary"
                class="mt-2"
                :disabled="buttonDisabled"
                @click.native="submit"
              >
                {{
                  page.selectedPosts.length > 1
                    ? "Générer les brouillons"
                    : "Générer le brouillon"
                }}</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      timeout="-1"
      top
      class="snackbar-center"
    >
      <div>
        <strong>{{ snackbar.message }}</strong>
        <!-- Optionnel : afficher les topics détaillés -->
        <ul v-if="snackbar.details && snackbar.details.length">
          <li v-for="item in snackbar.details" :key="item.topic">
            {{ item.topic }} :
            {{ item.status === "success" ? "✅ OK" : "❌ Erreur" }}
          </li>
        </ul>
      </div>

      <template v-slot:action>
        <v-btn
          v-for="action in snackbar.actions"
          :key="action.text"
          color="primary"
          dark
          large
          elevation="2"
          class="ma-2"
          @click="action.onClick()"
        >
          ✅ {{ action.text }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { computed, reactive, watch } from "@vue/composition-api";
import AifImageModeToggle from "@/components/ai-factory/common/AifImageModeToggle.vue";
import CustomPromptTemplateFilter from "@/components/ai-factory/full-auto/filters/CustomPromptTemplateFilter.vue";
import Filters from "@/components/ai-factory/post-by-discover/filters/Filters.vue";
import FilterSiteOut from "@/components/ai-factory/post-by-discover/filters/FiltersSiteOut.vue";
import PostResults from "@/components/ai-factory/post-by-discover/tables/Results.vue";
import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import { NEWS_RADAR_CRAWLER_DAGS } from "@/utils/constants";
export default {
  name: "GeneratePostDiscoverProcess",
  components: {
    AifImageModeToggle,
    CustomPromptTemplateFilter,
    Filters,
    PostResults,
    FilterSiteOut,
  },
  setup(props, { emit }) {
    const { axiosGet, axiosPost } = useAxios();
    const { route, store, router } = useProxy();

    const snackbar = reactive({
      show: false,
      message: "",
      color: "success",
      actions: [],
    });

    const page = reactive({
      clickedOnce: false,
      dags: NEWS_RADAR_CRAWLER_DAGS,
      loading: false,
      selectedPosts: [],
      site_id_out: 0,
      keepTitle: true,
      keepImage: true,
    });

    const imageHandler = computed({
      get: () => store.getters["aiFactory/getGenerationImageHandler"],
      set: (value) =>
        store.dispatch("aiFactory/updateGenerationImageHandler", value),
    });

    // =>  METHODS
    const handleSiteOutChange = (value) => {
      page.site_id_out = value;
      console.log("Nouvelle valeur de site_id_out :", value);
    };
    const resetState = () => {
      page.selectedPosts = [];
    };

    const selectPosts = (data) => {
      page.selectedPosts = data;
      console.log("adn_post_selected", page.selectedPosts);
    };

    const submit = async () => {
      const results = []; // <-- on stocke le résultat de chaque tentative

      for (const item of page.selectedPosts) {
        const payload = {
          adn_post_id: item,
          site_id_out: page.site_id_out,
          aif_custom_prompt_template_id: selectedTemplateId.value,
          keep_title: page.keepTitle,
          keep_image: page.keepImage,
          ...(page.keepImage ? {} : { image_handler: imageHandler.value }),
        };
        try {
          const response = await axiosPost(
            "/api/ai-factory/add-to-post-generation-queue-and-flag-source-discover",
            payload
          );
          results.push({ topic: item, status: "success" });
        } catch (error) {
          console.error(error);
          results.push({ topic: item, status: "error" });
        }
      }

      // Construire un message récapitulatif
      const successCount = results.filter((r) => r.status === "success").length;
      const errorCount = results.length - successCount;
      snackbar.message = `✅ ${successCount} brouillon(s) généré(s) avec succès · ❌ ${errorCount} en erreur`;
      snackbar.color = errorCount > 0 ? "error" : "success";
      snackbar.details = results;
      snackbar.show = true;
      snackbar.actions = [
        {
          text: "OK",
          onClick: () =>
            router.push({
              name: "ai-factory-post-generation-list",
              query: page.site_id_out ? { site_id: page.site_id_out } : {},
            }),
        },
      ];
    };

    // =>  COMPUTED
    const applyFilters = computed(
      () => store.getters["common/getApplyFilters"]
    );
    const buttonDisabled = computed(
      () => page.selectedPosts.length === 0 || page.site_id_out <= 0
    );
    const selectedTemplateId = computed(
      () =>
        Number(store.getters["aiFactory/getCustomPromptTemplate"] || 0) || null
    );

    // =>  WATCH
    watch(applyFilters, () => {
      if (applyFilters.value) {
        page.clickedOnce = true;
        resetState();
      }
    });

    // =>  HOOKS
    // =>  DATA

    return {
      imageHandler,
      page,
      selectedTemplateId,
      snackbar,
      buttonDisabled,
      selectPosts,
      submit,
      handleSiteOutChange,
    };
  },
};
</script>
